/**
 * React Components
*/
class FullScreenButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fullscreen: false
    }
  }

  handleFullscreenChange(e)
  {
    let fullscreen = ( document.fullscreenElement || document.mozFullScreenElement|| document.webkitFullscreenElement || document.msFullscreenElement || document.fullscreen || document.mozFullScreen || document.webkitIsFullScreene || document.fullScreenMode ) ? true : false;

    this.setState ({ fullscreen });

    this.props.fullscreen( fullscreen );
  }

  handleToggle(e)
  {
    e.preventDefault();

    const element = this.props.element;

    element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen || function () { return false; };

    document.cancelFullScreen = document.cancelFullScreen || document.exitFullscreen || document.webkitCancelFullScreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen || function () { return false; };

    const { fullscreen } = this.state;

    if ( !fullscreen ) {
      element.requestFullScreen();
    }
    else {
      document.cancelFullScreen();
    }
  }

  componentDidMount()
  {
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this), false)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange.bind(this), false)
    document.addEventListener('msfullscreenchange', this.handleFullscreenChange.bind(this), false)
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange.bind(this), false) //IE11
    document.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this), false)
  }

  componentWillUnmount()
  {
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this))
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange.bind(this))
    document.removeEventListener('msfullscreenchange', this.handleFullscreenChange.bind(this))
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange.bind(this)) //IE11
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange.bind(this))
  }

  render()
  {
    return (
      <button
        className={ this.props.className }
        onClick={ (e) => { this.handleToggle(e) } }
      >
        { this.props.children }
      </button>
    )
  }
}

export default FullScreenButton;


// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/misc/FullScreenButton.js